












































import { Component, Prop, Vue } from "vue-property-decorator";
import { ProjectBudgetViewModel, ProjectViewModel } from "@/services/api/nswag/stapiclient_generated";
import { UserStore } from "@/store/user-module";
import StProgress from "@/components/basic/StProgress.vue";

@Component({
  components: {
    StProgress
  },
})
export default class ProjectBudget extends Vue {
  @Prop() project!: ProjectViewModel;
  @Prop() budgetLoading!: boolean;
  @Prop() canViewBudget!: boolean;
  @Prop() hasBudget!: boolean;
  @Prop() budget!: ProjectBudgetViewModel;

  get currency() {
    return UserStore.userSettings.currency;
  }

  get canViewRates(): boolean {
    return UserStore.userSettings.CanViewRates;
  }
}
